import { atom } from 'jotai';

export interface UserLocation {
    lat: number;
    lng: number;
    timestamp: number; // Date.now()
}

const STORAGE_KEY = 'dokocrew_user_location';

const loadInitial = (): UserLocation | null => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as UserLocation;
        if (typeof parsed.lat !== 'number' || typeof parsed.lng !== 'number' || typeof parsed.timestamp !== 'number') return null;
        return parsed;
    } catch {
        return null;
    }
};

/** 내부 atom — 직접 사용하지 말고 useUserLocation 훅을 통해 접근 */
const baseLocationAtom = atom<UserLocation | null>(loadInitial());

/** 현재 위치 — localStorage에 자동 영속화 */
export const userLocationAtom = atom<UserLocation | null, [UserLocation | null], void>(
    (get) => get(baseLocationAtom),
    (_get, set, next) => {
        set(baseLocationAtom, next);
        try {
            if (next) localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
            else localStorage.removeItem(STORAGE_KEY);
        } catch { /* storage full 등 무시 */ }
    }
);

/** 위치 요청 중 여부 */
export const isLocationFetchingAtom = atom<boolean>(false);

/** 캐시 유효 시간 (5분) */
export const LOCATION_CACHE_MS = 5 * 60 * 1000;
